Namespace 'Settings.Views.Topics'

class Settings.Views.Topics.ReclameaquiChannelView extends Settings.Views.Topics.ChannelView
  sourceClassName: 'Keepcon::ReclameAquiSource'
  provider: 'reclameaqui'
  sourceIcon: image_path('source_ra.png')
